import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DASHBOARD_CONFIG } from 'src/app/core/config/config.constants';
import { environment } from 'src/environments/environment';
import { Dashboard, DashboardConfig } from '../dashboards/models/dashboard-models';
import { Vertical } from './models';
import { getMultiLanguageFieldTitle } from 'src/app/shared/customization/multilang-input/multi-language';

@Injectable({
  providedIn: 'root'
})
export class ConfigPortalService {

  private baseEndpoint = DASHBOARD_CONFIG;
  private baseUrl: string = environment.baseTsOhwUrl;

  actualVertical: Vertical | null = null;
  
  constructor(private _httpClient: HttpClient) { }

  getVerticalConfig(verticalType: string, customerId: string, uidUser: string): Observable<any> {
    const queryString = `?scope=${'vertical_' + verticalType}&uidCustomer=${customerId}&uidUser=${uidUser}&includeAncestorPath=true`;
    return this._httpClient.get(this.baseUrl + this.baseEndpoint + queryString).pipe(
      map((res: any) => {
        localStorage.setItem('vertical_' + verticalType, JSON.stringify(res.data[0]));
        this.actualVertical = res.data[0];
        return res;
      })
    );
  }

  createVerticalConfig(vertical: any) {
    return this._httpClient.post(this.baseUrl + this.baseEndpoint, vertical);
  }

  editVerticalConfig(vertical: any) {
    return this._httpClient.put(this.baseUrl + this.baseEndpoint, vertical).pipe(
      map((res: any) => {
        localStorage.setItem('vertical_' + vertical.scope, JSON.stringify(vertical));
        this.actualVertical = vertical;
        return res;
      })
    );
  }

  editVerticalFromDashboard(dashboard: DashboardConfig) {
    const vertical: Vertical = this.actualVertical ?? JSON.parse(localStorage.getItem('vertical_agri')!); // After user.vertical property
    vertical.config.menu.push({
      name: 'dashboard',
      label: getMultiLanguageFieldTitle(dashboard.config.name),
      cssClass: getMultiLanguageFieldTitle(dashboard.config.name).replace(/ /g, '-').toLowerCase(),
      icon: dashboard.config.icon || 'dashboard',
      link: `/app/dashboards/dashboard/${dashboard.id}`,
      type: dashboard.config.type,
      child: [],
      order: 999,
      w: false,
      hidden: dashboard.config.hiddenMenuItem
    });

    this.editVerticalConfig(vertical).subscribe();
  }

  removeDashboardFromVertical(dashboardId: string) {
    const vertical: Vertical = this.actualVertical ?? JSON.parse(localStorage.getItem('vertical_agri')!); // After user.vertical property
    vertical.config.menu = vertical.config.menu.filter(item => !item.link?.includes(dashboardId));
    this.editVerticalConfig(vertical).subscribe();
  }
}